// extracted by mini-css-extract-plugin
export default {"addOns":"addOns-Y5bIy","backToInventory":"backToInventory-1ZP-N"};